export const TIMELINE_FIXED_COLUMN_WIDTH = 260;
export const TIMELINE_DAY_WIDTH = 28;
export const TIMELINE_WEEK_DAY_WIDTH = 80;
export const TIMELINE_MONTH_WIDTH = 160;
export const TIMELINE_HEADER_TOP_HEIGHT = 39;
export const TIMELINE_HEADER_BOTTOM_HEIGHT = 37;
export const TIMELINE_HEADER_HEIGHT =
  TIMELINE_HEADER_TOP_HEIGHT + TIMELINE_HEADER_BOTTOM_HEIGHT;
export const TIMELINE_ROW_HEIGHT = 40;
export const TIMELINE_ADD_ENTRY_ROW_HEIGHT = 40;
export const TIMELINE_BAR_HEIGHT = 22;
export const TIMELINE_ONE_SIDED_BAR_WIDTH = 60;
export const TIMELINE_BAR_VERTICAL_INSET =
  (TIMELINE_ROW_HEIGHT - TIMELINE_BAR_HEIGHT) / 2;
export const TIMELINE_BAR_INSET = 8;
export const TIMELINE_MONTH_BUFFER_MONTHS = 24;
